import React from 'react';
import { useEffect, useState } from 'react';
import { Typography, Stack, Box, Dialog, DialogTitle, IconButton, DialogContent, DialogActions, Button, Divider, Checkbox, DialogContentText, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Link } from '@mui/material';
import { blue } from '@mui/material/colors';
import { Close, Drafts } from '@mui/icons-material';
import dayjs, { Dayjs } from 'dayjs';

import FilerFine from '../dataObjects/FilerFine';
import { NoticeTypeEnums } from '../dataObjects/NoticeTypeEnums';
import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';

interface MoreFollowUpNoticesProps {
    isFollowUpDialogOpen: boolean;
    closeFollowUpDialog: () => void;
    currentFineInfo?: FilerFine | null;
}

const MoreFollowUpNotices = (props: MoreFollowUpNoticesProps): JSX.Element => {

    const [emailContent, setEmailContent] = useState('');
    const [isEmailNotice, setEmailNotice] = useState(false);
    const [isPaperNotice, setPaperNotice] = useState(false);
    const [draftNoticeUrl, setDraftNoticeUrl] = useState<string | null>(null);
    const frameHeight = '800px';

    const ThirtyDayEmailDate = props.currentFineInfo ? dayjs(props.currentFineInfo.resolutionDeadline).add(31, "day").format("MM/DD/YYYY"): "";
    const SixtyDayEmailDate = props.currentFineInfo ? dayjs(props.currentFineInfo.resolutionDeadline).add(61, "day").format("MM/DD/YYYY") : "";
    const NinetyDayEmailDate = props.currentFineInfo ? dayjs(props.currentFineInfo.resolutionDeadline).add(91, "day").format("MM/DD/YYYY") : "";
    const FinalEmailDate = props.currentFineInfo ? dayjs(props.currentFineInfo.resolutionDeadline).add(121, "day").format("MM/DD/YYYY") : "";

    const noticeType = props.currentFineInfo && props.currentFineInfo.resolvedDate ? 'Fine' : 'Late';

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    useEffect(() => {
    }, []);

    const getDraftEmailContent = (fineNoticeType: number) => {
        let fineIssueId = props.currentFineInfo?.fineIssueId;
        fetch(`/FineTracker/GetHtmlNotice?fineIssueId=${fineIssueId}&fineNoticeType=${fineNoticeType}`)
            .then(result => result.text())
            .then(result => {
                setEmailContent(result);
                setEmailNotice(true);
                setPaperNotice(false);
            }
        )
    }

    const getPaperNotice = (fineNoticeType:number) => {
        let fineIssueId = props.currentFineInfo?.fineIssueId;
        let draftPdfUrl = `/FineTracker/GetPdfNotice?fineIssueId=${fineIssueId}&fineNoticeType=${fineNoticeType}`;
        setDraftNoticeUrl(draftPdfUrl);
        setEmailNotice(false);
        setPaperNotice(true);
    }

    const updatePaperNotice = (typeId: number, event: React.ChangeEvent<HTMLInputElement>) => {

        let isSent = event.target.checked;
        let id = props.currentFineInfo?.fineIssueId;
        fetch(`/fineTracker/UpdatePaperNoticeStatus?id=${id}&isSent=${isSent}&noticeTypeId=${typeId}`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: UpdatePaperNoticeStatus',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
            }
        )
    }

    return (
        <>
            <Dialog
                open={props.isFollowUpDialogOpen}
                scroll={'paper'}
                fullWidth={true}
                maxWidth={'md'}
                keepMounted
                onClose={props.closeFollowUpDialog}
                sx={{
                    "& .MuiDialog-container": {
                        justifyContent: "flex-end",
                        alignItems: "flex-end"
                    }
                }}
                PaperProps={{
                    sx: {
                        m: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        minHeight: '100vh'
                    }
                }}
            >
                <DialogTitle>
                    {
                        props.currentFineInfo &&
                        <Stack spacing={0.5}>
                            <Typography variant="subtitle1" sx={{ color: blue[800] }}>
                                {props.currentFineInfo.cpfId} {props.currentFineInfo.fullName}
                            </Typography>
                             <Typography variant="body2" color="error">
                                {props.currentFineInfo.auditPeriodId} missing reports are {props.currentFineInfo.daysLate} days late.
                                {
                                    props.currentFineInfo.resolvedDate &&
                                    <span>{' '} Resolved on {props.currentFineInfo.resolvedDate}. Current Fine Amount: {props.currentFineInfo.modifiedFineAmount} </span>
                                }
                             </Typography>
                                {

                                }
                        </Stack>
                    }
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={props.closeFollowUpDialog}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent dividers>
                    <TableContainer component={Paper} >
                        <Table aria-label="More Follow Up Table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Issue Due Date</TableCell>
                                    <TableCell>Notice Type</TableCell>
                                    <TableCell>Email Notice</TableCell>
                                    <TableCell>Paper Notice Sent</TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                props.currentFineInfo && 
                                <TableBody>
                                    <TableRow>
                                        <TableCell>{props.currentFineInfo.resolutionDeadline}</TableCell>
                                            <TableCell>30 Days {noticeType} Notice</TableCell>
                                        <TableCell>
                                            <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Drafts color="warning" sx={{ fontSize: "18px" }} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getDraftEmailContent(NoticeTypeEnums.ThirtyDay)} >
                                                        {ThirtyDayEmailDate}
                                                    </Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Checkbox defaultChecked={props.currentFineInfo.thirtyDayNoticePaperDate ? true : false} onChange={(event) => updatePaperNotice(NoticeTypeEnums.ThirtyDay, event)} size="small" />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getPaperNotice(NoticeTypeEnums.ThirtyDay)}>
                                                    View
                                                </Typography>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                            <TableCell>{props.currentFineInfo.resolutionDeadline}</TableCell>
                                            <TableCell>60 Days {noticeType} Notice</TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Drafts color="warning" sx={{ fontSize: "18px" }} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getDraftEmailContent(NoticeTypeEnums.SixtyDay)}>
                                                        {SixtyDayEmailDate}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Checkbox defaultChecked={props.currentFineInfo.sixtyDayNoticePaperDate ? true : false} size="small" onChange={(event) => updatePaperNotice(NoticeTypeEnums.SixtyDay, event)} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getPaperNotice(NoticeTypeEnums.SixtyDay)}>
                                                        View
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    <TableRow>
                                            <TableCell>{props.currentFineInfo.resolutionDeadline}</TableCell>
                                            <TableCell>90 Days {noticeType} Notice</TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Drafts color="warning" sx={{ fontSize: "18px" }} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getDraftEmailContent(NoticeTypeEnums.NinetyDay)}>
                                                        {NinetyDayEmailDate}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Checkbox defaultChecked={props.currentFineInfo.ninetyDayNoticePaperDate ? true : false} size="small" onChange={(event) => updatePaperNotice(NoticeTypeEnums.NinetyDay, event)} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getPaperNotice(NoticeTypeEnums.NinetyDay)}>
                                                        View
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    <TableRow>
                                            <TableCell>{props.currentFineInfo.resolutionDeadline}</TableCell>
                                            <TableCell>Final {noticeType} Notice</TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Drafts color="warning" sx={{ fontSize: "18px" }} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getDraftEmailContent(NoticeTypeEnums.Final)}>
                                                        {FinalEmailDate}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.2} alignItems="center">
                                                    <Checkbox defaultChecked={props.currentFineInfo.finalNoticePaperDate ? true : false} size="small" onChange={(event) => updatePaperNotice(NoticeTypeEnums.Final, event)} />
                                                    <Typography variant={'body2'} component={Link} onClick={() => getPaperNotice(NoticeTypeEnums.Final)}>
                                                        View
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                </TableBody>
                            }
                        </Table>
                    </TableContainer>
                    <Divider sx={{ marginTop: "20px", marginBottom: "20px" }} />
                    {
                        isEmailNotice &&
                        <Box sx={{ width: '100%', p: 2, border: '1px solid grey', bgcolor: '#fafafa' }}>
                            <DialogContentText dangerouslySetInnerHTML={{ __html: emailContent }}></DialogContentText>
                        </Box>
                        
                    }
                    {
                        isPaperNotice && draftNoticeUrl &&
                        <iframe src={draftNoticeUrl} width="99%" height={frameHeight} />
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.closeFollowUpDialog} variant="contained" color="warning">Cancel</Button>
                </DialogActions>
            </Dialog>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>

    );
};

export default MoreFollowUpNotices;